module.exports = __webpack_public_path__ + "static/media/success_tick.09c13ca8.svg";